import axios from "axios";

// const dotenv = require('dotenv');
// const dotenvExpand = require('dotenv-expand');
// // mar17 changes
// const myEnv = dotenv.config();
// dotenvExpand(myEnv);
// // 

axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
  //  axios.defaults.baseURL = "http://15.206.231.25:9700/v1";
  //  axios.defaults.baseURL = "http://54.221.108.254:9700/v1";
  //  axios.defaults.baseURL = "http://54.225.201.24:9700/v1";
// axios.defaults.baseURL = "https://localhost:9701/v1";
// axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
// axios.defaults.baseURL = "https://15.206.231.25:9700/v1";